import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Header.css';
import brandLogoImg from '../../assets/logo1.png'; 

const NAV_LINKS = [
  { label: 'Home', hash: '#home' },
  { label: 'Courses', hash: '#courses' },
  { label: 'Success Stories', hash: '#stories', matchHashes: ['#stories', '#success-stories'] },
  { label: 'My Learnings', hash: '#mylearning', authOnly: true, matchHashes: ['#mylearning', '#dashboard'] },
  { label: 'Blog', hash: '#blog' },
  { label: 'About Us', hash: '#about' }
];

export default function Header({ onLoginClick, currentUser, onLogout, onProfileClick }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeHash, setActiveHash] = useState('#home');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const syncHash = () => setActiveHash(window.location.hash || '#home');
    syncHash();
    window.addEventListener('hashchange', syncHash);
    return () => window.removeEventListener('hashchange', syncHash);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const navigate = (hash) => {
    window.location.hash = hash;
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  const handleLogin = () => {
    setMenuOpen(false);
    if (onLoginClick) onLoginClick();
    else window.location.hash = '#login';
  };

  const handleLogout = () => {
    setDropdownOpen(false);
    setMenuOpen(false);
    if (onLogout) onLogout();
  };

  const handleOpenProfile = () => {
    setDropdownOpen(false);
    setMenuOpen(false);
    if (onProfileClick) onProfileClick();
  };

  const isLinkActive = (item) => {
    if (item.matchHashes) return item.matchHashes.includes(activeHash);
    return activeHash === item.hash;
  };

  const userAvatar = currentUser?.avatar || 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&q=80';
  const userIdentifier = currentUser?.phone || currentUser?.email || '';

  return (
    <header className="header-container">
      
      <div className="brand-logo" onClick={() => navigate('#home')}>
        <img src={brandLogoImg} alt="Creators Dost" className="brand-logo-img" />
      </div>

      <div
        className={`nav-menu-backdrop ${menuOpen ? 'backdrop-visible' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      <nav className={`navigation-links ${menuOpen ? 'mobile-open' : ''}`}>
        {NAV_LINKS.filter((item) => !item.authOnly || currentUser).map((item) => (
          <a
            key={item.hash}
            href={item.hash}
            className={`nav-item ${isLinkActive(item) ? 'active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            {item.label}
          </a>
        ))}

        <div className="mobile-only-auth-container">
          {!currentUser ? (
            <button className="mobile-login-btn" onClick={handleLogin}>
              Log in
            </button>
          ) : (
            <div className="mobile-user-drawer-block">
              <div className="mobile-user-info-row" onClick={handleOpenProfile}>
                <img src={userAvatar} alt="Avatar" className="mobile-avatar" />
                <div>
                  <h4>{currentUser.name}</h4>
                  <p>{userIdentifier}</p>
                </div>
              </div>
              <button className="mobile-profile-btn" onClick={handleOpenProfile}>
                ⚙️ View & Edit Profile
              </button>
              <button className="mobile-logout-btn" onClick={handleLogout}>
                🚪 Log Out
              </button>
            </div>
          )}
        </div>
      </nav>

      <div className="action-auth-block" ref={dropdownRef}>
        {!currentUser ? (
          <button className="join-premium-btn" onClick={handleLogin}>
            Log in
          </button>
        ) : (
          <div className="user-profile-header-pill">
            <button
              type="button"
              className={`user-profile-trigger-btn ${dropdownOpen ? 'active' : ''}`}
              onClick={() => setDropdownOpen((prev) => !prev)}
              aria-label="User Profile Menu"
            >
              <img src={userAvatar} alt={currentUser.name} className="user-header-avatar" />
              <span className="user-header-name">{currentUser.name}</span>
              <span className={`dropdown-chevron ${dropdownOpen ? 'open' : ''}`}>▾</span>
            </button>

            {dropdownOpen && (
              <div className="header-profile-dropdown-drawer">
                <div className="dropdown-user-summary" onClick={handleOpenProfile} style={{ cursor: 'pointer' }}>
                  <img src={userAvatar} alt="Avatar" />
                  <div className="dropdown-user-text">
                    <h5>{currentUser.name}</h5>
                    <p>{userIdentifier}</p>
                  </div>
                </div>

                <div className="dropdown-menu-links">
                  <div className="dropdown-menu-item" onClick={handleOpenProfile}>
                    <span className="dropdown-item-icon">👤</span>
                    <span>My Profile</span>
                  </div>
                  <div className="dropdown-menu-item" onClick={() => navigate('#mylearning')}>
                    <span className="dropdown-item-icon">🎓</span>
                    <span>My Learnings</span>
                  </div>
                  <div className="dropdown-menu-item" onClick={() => navigate('#courses')}>
                    <span className="dropdown-item-icon">📦</span>
                    <span>Explore Courses</span>
                  </div>
                </div>

                <div className="dropdown-footer-logout" onClick={handleLogout}>
                  <span>🚪</span> Log Out
                </div>
              </div>
            )}
          </div>
        )}

        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}